module.exports = __webpack_public_path__ + "img/E-bike.2de3eae.svg";